import { Component, OnInit } from '@angular/core';
import { IStepValidation, WizardStep } from '../../../dialogs/wizard/WizardStep';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UserType } from '../../../store/models/user.model';

@Component({
  selector: 'app-select-role-wizard-step',
  templateUrl: './select-role-wizard-step.component.html',
  styleUrls: ['./select-role-wizard-step.component.scss'],
})
export class SelectRoleWizardStepComponent implements OnInit, WizardStep {
  static NAME = 'select-role-wizard-step';
  wizardData: { [key: string]: any; };
  roles = UserType;
  currentRole: string;

  formGroup: FormGroup;

  constructor() {
  }

  provideData() {
    return this.formGroup.value;
  }

  async validate(): Promise<IStepValidation> {
    return {
      success: this.formGroup.valid,
      errors: this.formGroup.valid ? undefined : ['You must specify a valid role'],
    };
  }

  ngOnInit(): void {
    this.formGroup = new FormGroup({
      role: new FormControl(this.wizardData[SelectRoleWizardStepComponent.NAME].role ?? (this.currentRole ?? UserType.SINGLE_USER), [Validators.required]),
    });
  }

}
